var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIcChevronRightWinline = function SvgIcChevronRightWinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.601 28.955a1.267 1.267 0 010-1.824L20.024 16 8.6 4.87a1.267 1.267 0 010-1.825 1.349 1.349 0 011.873 0L23.769 16 10.474 28.955a1.349 1.349 0 01-1.873 0z",
    fill: "#fff"
  })));
};
export default SvgIcChevronRightWinline;